import { useContext } from 'react';
import type { CustomFeature } from '@types';
import CustomFeatureContext from './CustomFeatureContext';
import type { CFSetData } from './typeHelpers';

function useCustomFeature<T extends Partial<CustomFeature>>() {
  const { data, setData } = useContext(CustomFeatureContext);
  return { data: data as T, setData: setData as CFSetData<T> };
}

export default useCustomFeature;
